import { render, staticRenderFns } from "./presentation_landing_card.vue?vue&type=template&id=00c300d5&"
import script from "./presentation_landing_card.vue?vue&type=script&lang=js&"
export * from "./presentation_landing_card.vue?vue&type=script&lang=js&"
import style0 from "./presentation_landing_card.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports